export class BigIntMath {
  value: bigint

  constructor(value: bigint) {
    this.value = value
  }

  add(other: bigint): bigint {
    return this.value + other
  }

  subtract(other: bigint): bigint {
    return this.value - other
  }

  multiply(other: bigint): bigint {
    return this.value * other
  }

  divide(other: bigint): bigint {
    return this.value / other
  }

  modulo(other: bigint): bigint {
    return this.value % other
  }

  power(exponent: bigint): bigint {
    return this.value ** exponent
  }

  abs(): bigint {
    return this.value < 0n ? -this.value : this.value
  }

  toString(): string {
    return this.value.toString()
  }

  static fromString(str: bigint): bigint {
    return str
  }

  static max(a: bigint, b: bigint): bigint {
    return a > b ? a : b
  }

  static min(a: bigint, b: bigint): bigint {
    return a < b ? a : b
  }
}
